import { WebStorage } from 'proxy-storage';
import urlParameter from '../../../utils/url/urlParameter';

const
  sessionId = new WebStorage('cookieStorage').getItem('healthcareSession') || '',
  servicePlanPayload = {
    Applicant: {
      Holder: {
        FirstName: '',
        LastName: '',
        TypePerson: 0,
        TypeGender: 1,
        TabacoUse: 0,
        DateOfBirth: '1951/01/01', // yyyy/MM/dd
      },
      GeoLocation: {
        zipCode: '',
        stateId: 0,
        stateAcronym: '',
        stateName: '',
        countyId: 0,
        countyName: '',
        displayName: '',
        city: '',
        fips: '',
      },
      FilterSelected: [],
      f: 1,
    },
    TrackObject: {
      VisitId: sessionId,
      SessionId: sessionId,
    },
    Ircid: '',
    PublisherCampaignId: 37,
    SRC: urlParameter('SRC') || 'ORGANIC',
    Placement: 'Blog',
  };

export const featureAdsPayload = {
  hc_session: sessionId,
  src: urlParameter('SRC') || 'ORGANIC',
  hc_state: '',
  hc_zip: '',
  hc_placement: 'WIDGET_ADS',
  hc_product_type: 1,
  product: 'HEALTH',
  PublisherCampaignId: 47,
};

export const rotationToolPayload = {
  LocationInfo: {
    CountyName: '',
    StateAchronym: '',
    StateName: '',
  },
  placement: 'WIDGET_ADS',
  product: '',
  JsonIn: {
    user_agent: window.navigator.userAgent,
    origin: document.domain,
    src: urlParameter('SRC') || 'ORGANIC',
    zip: '',
    max_results: 0,
    device: 'desktop',
    applicant_city: '',
    hc_session: sessionId,
  },
};

export default servicePlanPayload;
